import React, { useContext, useEffect, useState } from "react";
import Form from "../../../components/form";
import api from "../../../services/api";
import AppContext from "../../../container/context";
import { CircularProgress } from "@mui/material";

let cpf = "";

export default function Cadastro(props) {
  const [consuId] = useState(Number(props.match.params.id));
  const { notification } = useContext(AppContext);
  const [dados, setDados] = useState({
    nome: "",
    cpf: "",
    email: "",
    senha: "",
  });
  const [carregando, setCarregando] = useState(false);
  const [usuarioId, setUsuarioId] = useState(0);

  const history = props.history;

  useEffect(() => {
    if (consuId) {
      carregarConsultor();
    }
  }, []);

  const carregarConsultor = () => {
    setCarregando(true);
    api
      .get("consultores/carregar", { id: consuId })
      .then((res) => {
        let dadosProf = {
          nome: res.usuarioNome,
          CPF: res.usuarioCpf,
          email: res.usuarioEmail,
        };
        setUsuarioId(res.usuarioId);
        setDados(dadosProf);
        setCarregando(false);
      })
      .catch((err) => {
        setCarregando(false);

        notification("error", "Não localizado");
      });
  };

  const vincular = (form) => {
    cpf = form.cpf;

    api
      .post("consultores/vincular", { CPF: form.cpf })
      .then((res) => {
        notification("success", "Usuário vinculado com sucesso!");
        history.push("/app/consultor");
      })
      .catch((err) => {
        notification("error", "Não foi possível vincular");
      });
  };

  const cadastro = (params) => {
    let dadosParams = {
      nome: params.nome,
      CPF: params.CPF,
      email: params.email,
      senha: params.senha,
    };

    if (consuId) {
      api
        .post("usuarios/editar", {
          id: usuarioId,
          nome: params.nome,
          CPF: params.CPF,
          email: params.email,
        })
        .then((res) => {
          notification("success", "Dados cadastrais editado com sucesso!");
          carregarConsultor();
        })
        .catch((err) => {
          const { data } = err;
          switch (data[0]) {
            case 1:
              return notification("error", "Nome inválido");
            case 2:
              return notification("error", "CPF inválido");
            case 3:
              return notification("error", "Email inválido");
            case 4:
              return notification("error", "CPF já cadastrado");
            default:
              return notification("error", "Dados inválidos");
          }
        });
    } else {
      setDados(dadosParams);

      dadosParams.vinculacao = true;
      api
        .put("consultores/inserir", dadosParams)
        .then((res) => {
          notification("success", "Consultor cadastrado com sucesso!");
          history.push("/app/consultor");
        })
        .catch((err) => {
          const { data } = err;

          switch (data[0]) {
            case 1:
              return notification("error", "Nome inválido");
            case 2:
              return notification("error", "CPF inválido");
            case 3:
              return notification("error", "Email inválido");
            case 4:
              return notification("error", "Senha inválida");
            case 5:
              return notification("error", "Profissional já cadastrado");
            default:
              return notification("error", "Dados inválidos");
          }
        });
    }
  };

  const fVinculo = {
    title:
      "Usuário já tem conta na Perto? Informe o CPF do usuário para criar o cadastro de consultor",
    form: {
      cpf: {
        label: "CPF",
        type: "number",
        value: cpf,
      },
    },

    submit: {
      label: "salvar",
      action: vincular,
    },
  };

  const camposfiltros = () => {
    const campos = {
      nome: {
        label: "Nome",
        type: "text",
        space: 6,
        value: dados.nome,
      },
    };

    campos.CPF = {
      label: "CPF",
      type: "number",
      space: 3,
      value: dados.CPF,
    };

    campos.email = {
      label: "Email",
      type: "text",
      space: 3,
      value: dados.email,
    };

    if (consuId === 0) {
      campos.senha = {
        label: "Senha",
        type: "text",
        value: dados.senha,
      };
    }

    return campos;
  };

  const fFiltros = {
    title: consuId === 0 ? "Novo consultor" : "Consultor",
    form: camposfiltros(),
    submit: {
      label: "Salvar",
      action: cadastro,
    },
    history,
    close: true,
  };

  return (
    <div>
      {consuId === 0 && (
        <>
          <Form formData={fVinculo} />
        </>
      )}

      {carregando ? <CircularProgress /> : <Form formData={fFiltros} />}
    </div>
  );
}
